import React from 'react'

function UnitTreeBuilder({birims, loop = 0, SetUstBirimId, setHiyerarsiMap, categorytList,setParentNames}) {
  const newData = categorytList

  function setBirimId(item) {
    SetUstBirimId(item.id)
    setHiyerarsiMap(getParent(item))
    setParentNames(getParentNames(item))
  }

  function setFirstBirim(id) {
    SetUstBirimId(id)
    setHiyerarsiMap(String(id))
    setParentNames(getParentNames(id))
  }

  function getParent(item) {
    let parentID = item.parentId
    let x = item.id
    let ids = item.id
    do {
      let newParentData = newData.filter((i) => i.id === parentID)
      if (newParentData[0]) {
        ids = newParentData[0].id
        parentID = newParentData[0].parentId
        x = ids + '|' + x
      }
    } while (parentID > 0)
    return String(x)
  }

  function getParentNames(item) {
    let parentID = item.parentId;
    let names = item.name;
    let y=item.name
    if(item===0)
    {
      y="You added main parent."
    }
    else
    {  do {
      let newParentData = newData.filter((i) => i.id === parentID);
      if (newParentData[0]) {
        names = newParentData[0].name;
        parentID = newParentData[0].parentId;
        y = names + "|" + y;
      }
    } while (parentID > 0);

    }
   return String(y)
  }

  function TreeNode({node}) {
    const {subList, name} = node

    const [showChildren, setShowChildren] = React.useState(false)

    const handleClick = () => {
      setShowChildren(!showChildren)
    }
    return (
      <>
        {subList != null ? (
          <>
            <span className='list-group-item border-0 menu-item-has-children'>
              <a className='open2' onClick={handleClick}>
              <span>  
                {name}
                {showChildren ? (
                  <i className='fas fa-angle-right p-2'></i>
                ) : (
                  <i className='fas fa-angle-down p-2'></i>
                )}
       </span>
                <span className='btn btn-outline-dark mx-1 small' onClick={() => setBirimId(node)}>
                  <i className='fas fa-plus'></i>
                </span>
              </a>
              {showChildren && <Tree treeData={subList} />}
            </span>
          </>
        ) : (
          <span key={node.id} className='list-group-item border-0'>
            {name}
            <a className='btn btn-outline-dark mx-1 small' onClick={() => setBirimId(node)}>
              <i className='fas fa-plus'></i>
            </a>
          </span>
        )}
      </>
    )
  }

  function Tree({treeData}) {
    return (
      <>
        {treeData.map((node) => (
          <TreeNode node={node} key={node.id} />
        ))}
      </>
    )
  }

  return (
    <ul
      id='theList'
      className={loop === 0 ? 'list-group border-0' : 'list-group border-0 sub-menu2 '}
    >
      <div className='open2'>
        <a className='btn btn-outline-dark mx-1 small' onClick={() => setFirstBirim(0)}>
          <i className='fas fa-plus'></i>
        </a>
      </div>
      <Tree treeData={birims} />
    </ul>
  )
}

export default UnitTreeBuilder
